import { z } from 'zod'

import { clientTypeSchema } from 'src/shared/schemas/referrals/referral-fields/real-estate-agent/client-type'

import { expertiseSchema } from '../expertise'
import { professionSchema } from '../profession'

export const filtersSchema = z.object({
  expertise: z.array(expertiseSchema).optional(),
  profession: professionSchema.optional(),
  location: z.string().optional(),
  longitude: z.number().min(-180).max(180).optional(),
  latitude: z.number().min(-90).max(90).optional(),
  clientFocus: clientTypeSchema.optional(),
  city: z.string().optional(),
  state: z.string().optional(),
})

export type SearchFilters = z.infer<typeof filtersSchema>
